<!-- Login Section -->
<section
  class="d-flex flex-column justify-content-center align-items-center p-4 sectionWrap"
  *ngIf="state === 'login'"
>
  <h2 class="headingBL mb-5">Please <span>Login</span></h2>

  <div
    class="signin-content d-flex flex-column flex-md-row w-100 align-items-center justify-content-center gap-4"
  >
    <figure class="mb-4 mb-md-0">
      <img
        src="https://d2abnqj5vuy2s4.cloudfront.net/assets/images/signin-image.jpg"
        alt="Sign In"
        class="img-fluid"
        style="max-width: 20rem"
      />
    </figure>

    <div class="text-center text-md-start">
      <img
        src="assets/images/virsa-black-logo.png"
        alt="Virsa Logo"
        style="height: 4rem; object-fit: contain"
        class="mb-3"
      />

      <form
        [formGroup]="loginForm"
        (ngSubmit)="onSubmit()"
        class="d-flex flex-column gap-3"
      >
        <div class="form-group">
          <label for="your_name" class="form-label"
            >Enter Mobile or Email</label
          >
          <input
            type="text"
            id="your_name"
            class="form-input"
            placeholder="Mobile Number / Email"
            formControlName="your_name"
          />
        </div>

        <div class="form-check">
          <input
            type="checkbox"
            formControlName="agreeTerm"
            class="form-check-input"
            id="agreeTerm"
          />
          <label for="agreeTerm" class="form-check-label"
            >Get notifications on WhatsApp</label
          >
        </div>

        <button
          type="submit"
          class="btnGlobal--secondary w-100 d-flex justify-content-center align-items-center"
          [disabled]="!loginForm.valid || !isButtonOn"
        >
          <span *ngIf="isButtonOn">Log in</span>
          <div
            class="spinner-border text-light spinner-border-sm"
            role="status"
            *ngIf="!isButtonOn"
          >
            <span class="visually-hidden">Loading...</span>
          </div>
        </button>
      </form>
    </div>
  </div>
</section>

<!-- OTP Section -->
<section
  class="d-flex flex-column justify-content-center align-items-center p-4 sectionWrap"
  *ngIf="state === 'otp'"
>
  <h2 class="headingBL mb-5">Please <span>Enter OTP</span></h2>

  <div
    class="signin-content d-flex flex-column flex-md-row align-items-center justify-content-center gap-4"
  >
    <div class="text-center text-md-start">
      <img
        src="https://d2abnqj5vuy2s4.cloudfront.net/assets/images/ic_logo.png"
        alt="Virsa Logo"
        style="height: 4rem; object-fit: contain"
        class="mb-3"
      />

      <p>
        OTP has been sent to <strong>{{ data.number }}</strong>
        <a
          (click)="changeNumber()"
          class="ms-2 text-decoration-underline cursor-pointer"
          >Edit</a
        >
      </p>

      <div class="form-group my-3">
        <label for="otp_input" class="form-label">Enter Your OTP</label>
        <ng-otp-input
          #ngOtpInput
          (onInputChange)="onOtpChange($event)"
          [config]="config"
        ></ng-otp-input>
      </div>
      <button
        (click)="onOtpSubmit()"
        class="btnGlobal--secondary mt-3 w-100 d-flex justify-content-center align-items-center"
        [disabled]="!isButtonOn"
      >
        <span *ngIf="isButtonOn">Verify</span>
        <div
          class="spinner-border text-light spinner-border-sm"
          role="status"
          *ngIf="!isButtonOn"
        >
          <span class="visually-hidden">Loading...</span>
        </div>
      </button>
    </div>

    <figure class="mb-4 mb-md-0">
      <img
        src="https://d2abnqj5vuy2s4.cloudfront.net/assets/images/signin-image.jpg"
        alt="Sign In"
        class="img-fluid"
        style="max-width: 20rem"
      />
    </figure>
  </div>
</section>

<!-- Register Section -->
<section
  class="d-flex flex-column justify-content-center align-items-center p-4 sectionWrap"
  *ngIf="state === 'register'"
>
  <h2 class="headingBL mb-5">Please <span>Enter Details</span></h2>

  <div
    class="signup-content d-flex flex-column flex-md-row w-100 align-items-center justify-content-center gap-4"
  >
    <figure class="mt-4 mt-md-0">
      <img
        src="https://d2abnqj5vuy2s4.cloudfront.net/assets/images/signup-image.jpg"
        alt="Sign Up"
        class="img-fluid"
        style="max-width: 15rem"
      />
    </figure>

    <div class="text-center text-md-start">
      <h2 class="form-title mb-4">Register Now</h2>

      <form
        [formGroup]="registerForm"
        (ngSubmit)="onRegisterSubmit()"
        class="d-flex flex-column gap-3"
      >
        <div class="form-group">
          <label for="name" class="form-label">First Name</label>
          <input
            type="text"
            id="name"
            formControlName="name"
            class="form-input"
            placeholder="Your First Name"
          />
        </div>

        <div class="form-group">
          <label for="last_name" class="form-label">Last Name</label>
          <input
            type="text"
            id="last_name"
            formControlName="last_name"
            class="form-input"
            placeholder="Your Last Name"
          />
        </div>

        <div class="form-group">
          <label for="email" class="form-label">Email</label>
          <input
            type="email"
            id="email"
            formControlName="email"
            class="form-input"
            placeholder="Your Email"
            [attr.disabled]="validateEmail(data.email) ? true : null"
          />
        </div>

        <button type="submit" class="btnGlobal--secondary w-100">Update</button>
      </form>
    </div>
  </div>
</section>
